// German for the new-engagement modal. Registered on load.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Client and name are required': 'Kunde und Name sind erforderlich',
  'Engagement {code} created': 'Auftrag {code} erstellt',
  'New engagement': 'Neuer Auftrag',
  'Client': 'Kunde',
  'select a client…': 'Kunde wählen…',
  'Name': 'Name',
  'Warehouse slotting optimisation': 'Optimierung der Lagerplatzvergabe',
  'Code — uppercase alnum, unique, immutable': 'Code — Grossbuchstaben und Ziffern, eindeutig, unveränderlich',
  'leave blank to derive from the client': 'leer lassen, um ihn aus dem Kunden abzuleiten',
  'Sponsor': 'Sponsor',
  'pick a client first': 'zuerst einen Kunden wählen',
  'not named yet': 'noch nicht benannt',
  'no contacts on this client': 'keine Kontakte bei diesem Kunden',
  'Who signs. Naming them here clears the counterpart condition on gate {gate}.': 'Wer unterzeichnet. Die Benennung hier erfüllt die entsprechende Bedingung auf Gate {gate}.',
  'Estimate ({currency})': 'Schätzung ({currency})',
  'Ballpark, before milestones exist.': 'Grössenordnung, bevor Meilensteine existieren.',
  'Commercial model': 'Kommerzielles Modell',
  'Fixed price': 'Festpreis',
  'Time & materials': 'Nach Aufwand',
  'Capped T&M': 'Nach Aufwand mit Kostendach',
  'Retainer': 'Retainer',
  'Currency': 'Währung',
  'Review window (d)': 'Prüffrist (T)',
  'Correspondence language': 'Korrespondenzsprache',
  'inherit from the client — {language}': 'vom Kunden übernehmen — {language}',
  'inherit from the client': 'vom Kunden übernehmen',
  'Everything produced inside the engagement — proposals, descriptors, questions — is written in it.': 'Alles, was im Auftrag entsteht — Vorschläge, Beschreibungen, Fragen — wird in ihr geschrieben.',
  'Parent engagement (optional)': 'Übergeordneter Auftrag (optional)',
  'none': 'keine',
  'Kickoff date (optional)': 'Kickoff-Datum (optional)',
  'The engagement opens in {phase} behind gate {gate}. Its code is used in refs and the agent workspace directory and cannot be changed later.': 'Der Auftrag beginnt in {phase} hinter Gate {gate}. Sein Code wird in Refs und im Arbeitsverzeichnis des Agenten verwendet und kann später nicht geändert werden.',
  'Qualify': 'Qualifizierung',
  'Cancel': 'Abbrechen',
  'Creating…': 'Wird erstellt…',
  'Create engagement': 'Auftrag erstellen',
}, 'NewEngagementModal');
